const initialState = {
  loading: false,
  error: null
}

function loginReducer(state = initialState, action) {
  switch (action.type) {
    case 'AUTH_LOGIN_BEGIN':
      return {
        ...state,
        loading: true,
        error: null
      }

    case 'AUTH_LOGIN_SUCCESS':
      return {
        ...state,
        loading: false
      }

    case 'AUTH_LOGIN_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: 
      return state
  }
}

export default loginReducer